<div class="col-sm-12 ficheTransporteur" *ngIf="!isEmpty">
<div *ngIf="!isEmpty" class="header fiche">
    <div class="col-sm-6 fiche-client" style="padding: 0 15px;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">
        Tarif transporteur
    </div>
    <div class="col-sm-6 text-right" style="padding-right: 0;">
        <button class="btn-header uppercase" (click)="annuler()" id="close2">
            Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
            Valider </button>
    </div>
</div>
<mat-divider *ngIf="!isEmpty"></mat-divider>
<div *ngIf="!isEmpty" class="paramsociete article paramIndice contente">
    <div class="col-sm-12 ligneBon info-client" style="padding: 0;">
        <div class="group1 col-sm-12 tab-content" style="padding-top: 10px;">
            <ngx-datatable style="height: 100%" class="material cubage tab" [rows]="listPrix" [columnMode]="'force'" [headerHeight]="40"
                           [footerHeight]="0" [rowHeight]="40" [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">           
                <ngx-datatable-column name="Cubage">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Article </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="getID" id="{{rowIndex}}">
                            <!--
                            <app-autocomplete [placeholder]="row.article ? '' : 'Article'" (searchfunction)="searchArticle($event)"
                                [notOblig]="true" [label]="''" [selectvalue]="true" (selectfunction)="row.article = $event;" 
                                [container]="true" [results]="dataArticle" [id]="classPresta" 
                                [defaultsearch]="(row.article && row.article.id && row.article.id > 0) ? (row.article.code ? row.article.code : '') : ''" 
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>   
                            -->
                            <app-autocomplete [placeholder]="row.article ? '' : 'Article'" (searchfunction)="searchArticle($event)"
                                (selectfunction)="row.article = $event;" [notOblig]="true" [label]="''" [selectvalue]="true"
                                [disablefocus]="true" [container]="true" [selectvalue]="true" [results]="dataArticle" [id]="classPresta" 
                                [defaultsearch]="row.article ? (row.article.libelleObjetEntite ? row.article.libelleObjetEntite : row.article.libelle) : ''" 
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>                            
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cubage">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Exutoire </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="getID" id="{{rowIndex}}">
                            <app-autocomplete [placeholder]="row.exutoire ? '' : 'Exutoire'" (searchfunction)="searchExutoire($event)"
                                [notOblig]="true" [label]="''" [selectvalue]="true" (selectfunction)="row.exutoire = $event;" 
                                [container]="true" [results]="dataExutoire" [id]="classPresta" [disablefocus]="true"
                                [defaultsearch]="row.exutoire ? (row.exutoire.libelleObjetEntite || row.exutoire.nom) : dataExutoire[0].libelleObjetEntite" 
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>                               
                        </div>
                    </ng-template>
                </ngx-datatable-column>                       

                <ngx-datatable-column name="Valeur">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Tarif</span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <input type="number" class="form-control detailfact" [(ngModel)]="row.tarif">
                    </ng-template>
                </ngx-datatable-column> 
                           
                <ngx-datatable-column name="Valeur">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Type</span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <app-autocomplete (selectfunction)="row.qualitePrix = $event; common.focusElement('#autocomplete')"
                            [results]="listQualitePrix" [highlight]="true" [isCombo]="true" [disablefocus]="true"
                            id="classPresta" [placeholder]="'Qualité prix'" [defaultselected]="row.qualitePrix"
                            [container]="true" [defaultsearch]="row.qualitePrix ? row.qualitePrix.libelleObjetEntite : ''"></app-autocomplete>
                    </ng-template>
                </ngx-datatable-column>                                                       
                           
                <ngx-datatable-column name="Cubage">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Client </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="getID" id="{{rowIndex}}">
                            <app-autocomplete [placeholder]="row.client ? '' : 'Client'" (searchfunction)="searchClient($event)"
                                [notOblig]="true" [label]="''" [selectvalue]="true" (selectfunction)="row.client = $event;" 
                                [container]="true" [results]="dataClient" [id]="classPresta"   [selectvalue]="true"
                                [defaultsearch]="row.client ? (row.client.nomClient || row.client.libelleObjetEntite || '') : ''" [disablefocus]="true"
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>                               
                        </div>
                    </ng-template>
                </ngx-datatable-column>           
                           
                <ngx-datatable-column name="Cubage">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Chantier </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="getID" id="{{rowIndex}}">
                            <app-autocomplete [placeholder]="row.chantier ? '' : 'Chantier'" (searchfunction)="searchChantier(row, $event)"
                                [notOblig]="true" [label]="''" [selectvalue]="true" (selectfunction)="row.chantier = $event; row.chantier.libelleObjetEntite = row.chantier.numChantier" 
                                [container]="true"  [selectvalue]="true" [results]="dataChantier" [id]="classPresta" 
                                [defaultsearch]="row.chantier ? (row.chantier.numChantier || row.chantier.libelleObjetEntite || '') : ''" [disablefocus]="true"
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>                               
                        </div>
                    </ng-template>
                </ngx-datatable-column>                               
                           
                <ngx-datatable-column name="Cubage">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                                 let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Site </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="getID" id="{{rowIndex}}">
                            <app-autocomplete [placeholder]="row.site ? '' : 'Site'" 
                                [notOblig]="true" [label]="''" [selectvalue]="true" (selectfunction)="row.site = $event;" 
                                [container]="true" [results]="listeSite" [id]="classPresta"  [isCombo]="true"
                                [defaultsearch]="row.site ? row.site.libelleObjetEntite : ''" 
                                [autohide]="true" [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')"></app-autocomplete>                               
                        </div>
                    </ng-template>
                </ngx-datatable-column>                            
                
                <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                        <div class="text-right" style="padding-right: 5px;">
                            <!--
                            <button *ngIf="!row.edit" class="btn-detail" (click)="row.edit = !row.edit; showInput(rowIndex)">
                                <i class="fa fa-pencil"></i>
                            </button>
                            
                            <button *ngIf="row.edit" class="btn-detail save" (click)="save(row)">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </button>
                            -->
                            <button class="btn-detail cancel" (click)="deleteLigne(row)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div class="col-sm-12" style="padding: 0;">
                <button class="btn-add" (click)="addLigne()">
                    <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigne()"> Ajouter une ligne </span>          
            </div>              
        </div>
    </div>
</div>
</div>